import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { IMaskInput } from 'react-imask';
export const TextMask = React.forwardRef((props, ref) => {
    const { onChange, mask, keepMask, ...inputProps } = props;
    return (_jsx(IMaskInput, { inputRef: ref, mask: mask, lazy: false, ...inputProps, unmask: !keepMask, onAccept: (value) => {
            if (value === inputProps.value) {
                return;
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            onChange?.({
                target: { value }
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
            });
        } }));
});
